<!--
 * @Descripttion: 
 * @version: 
 * @Author: sueRimn
 * @Date: 2019-08-28 14:34:31
 * @LastEditors: sueRimn
 * @LastEditTime: 2020-03-26 11:19:52
 -->
<template>
  <div class="tabs">
    <el-dialog :width="width"  :title="title" :visible.sync="dialogFormVisible" :modal="modal" @close="close" class="dialog">
      <slot></slot>
      <div slot="footer" class="dialog-footer">
        <el-button v-show="cancelText" @click="cancel">{{cancelText}}</el-button>
        <el-button v-show="confirmText" type="primary" @click="confirm">{{confirmText}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
export default {
  data() {
    return {
      dialogFormVisible: false
    }
  },
  props: {
    title: {
      type: String
    },
    width: {
      type: String,
      default: '60%'
    },
    modal: {
      type: Boolean,
      default: true
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    confirmText: {
      type: String,
      default: '确定'
    }
  },

  created() {},

  computed: {},

  methods: {
    confirm() {
      // this.dialogFormVisible = false
      this.$emit('layerConfirm')
    },
    cancel() {
      // this.dialogFormVisible = false
      this.$emit('layerCancel')
    },
    layerToggle() {
      this.dialogFormVisible = !this.dialogFormVisible
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>
<style lang='scss' scoped>
// .tabs >>> .el-dialog{
//   width: 83%;
// }
</style>


// WEBPACK FOOTER //
// src/base/contentLayer/index.vue